export default __webpack_public_path__ + "static/media/DefaultProject.f4d1de13.jpg";